export default __webpack_public_path__ + "static/media/Saransh.bf14a603.jpg";